import { IntegerMarksType } from './iInputNumber'

export const defaultIntegerMarks: IntegerMarksType = [
  {
    len: 3,
    // mark: '百',
    key: 'hundred'
  },
  {
    len: 4,
    // mark: '千',
    key: 'thousand'
  },
  {
    len: 5,
    // mark: '万',
    key: 'tenThousand'
  },
  {
    len: 6,
    // mark: '十万',
    key: 'hundredThousand'
  },
  {
    len: 7,
    // mark: '百万',
    key: 'million'
  },
  {
    len: 8,
    // mark: '千万',
    key: 'tenMillion'
  },
  {
    len: 9,
    // mark: '亿',
    key: 'hundredMillion'
  },
  {
    len: 10,
    // mark: '十亿',
    key: 'billion'
  },
  {
    len: 11,
    // mark: '百亿',
    key: 'tenBillion'
  },
  {
    len: 12,
    // mark: '千亿',
    key: 'hundredBillion'
  },
  {
    len: 13,
    // mark: '万亿',
    key: 'trillion'
  },
  {
    len: 14,
    // mark: '十万亿',
    key: 'tenTrillion'
  },
  {
    len: 15,
    // mark: '百万亿',
    key: 'hundredTrillion'
  },
  {
    len: 16,
    // mark: '千万亿',
    key: 'quadrillion'
  },
]

/**
* 转化为金额大写
*/
export function convertToChineseCurrency(val: string | number) {
  const value = Number(val);

  if (typeof val === 'string' && /^[^-]*-$/.test(val)) return val[val.length - 1] + val.slice(0, val.length - 1);
  if (val === '' || val == null) return '';
  //  0显示为零元整
  if (value === 0) return '零元整';
  // 负数显示原数值
  if (value < 0) return val;
  if ((typeof val === 'string' && val.includes('e')) || Number.isNaN(value)) return '错误的金额！'

  // 15判断是因为如果有16位整数+两位小数，Number会丢失小数精度
  // eslint-disable-next-line prefer-const
  let [integer, decimal = '0'] = typeof val === 'string' && val.length > 15 ? val.split('.') : value.toString().split('.');

  integer = integer.replace(/^0+/, ''); // 删除所有开头的零
  const numArr = ['', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const descArr = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟', '万亿', '拾', '佰', '仟', '兆', '拾', '佰', '仟'];
  const rmbDescArr = ['角', '分'];

  // 整数部分的读法
  let integerRes = '';
  let count = integer.length; // 整数位数
  if (count > 16 || (count > String(Number.MAX_SAFE_INTEGER).length)) {
    return '错误的金额！';
  } else if (count === 0) {
    integerRes = '零';
  } else {
    for (let i = 0; i < count; i++) {
      const n = integer[i]; // 当前位上的数字
      // 当前数字的单位索引 descArr
      const j = count - i - 1;

      // 判断是否需要在数字前加“零”
      const isLing = i > 1 && n !== '0' && integer[i - 1] === '0'; // 去除首位且本位不是零上一位是零
      const cnZero = isLing ? '零' : '';
      // 获取当前数字的中文大写
      const cnNum = numArr[n as unknown as number]; // 类型断言，避免ts变严的类型审查导致标红

      // 判断当前单位是否需要省略
      const isEmptyUnit = (n === '0' && j % 4 !== 0) || integer.slice(i - 3, i + 1) === '0000';
      const cnDesc = isEmptyUnit ? '' : descArr[j];
      integerRes += cnZero + cnNum + cnDesc;
    }
  }

  // 小数部分的读法
  let decimalRes = '';
  count = (decimal || '').length;

  if (decimal === null) {
    decimalRes = '整';
  } else if (decimal === '0') {
    decimalRes = '';
  } else if (count > 2) {
    return '错误的金额！' // 规范，只处理两位小数情况
  } else {
    for (let i = 0; i < count; i++) {
      const n = decimal[i];
      // 判断是否需要在数字前加“零”
      const isLing = i > 0 && n !== '0' && decimal[i - 1] === '0';
      const cnZero = isLing && integerRes !== '零' ? '零' : '';
      const cnNum = numArr[n as unknown as number]; // 类型断言，避免ts变严的类型审查导致标红
      const cnDesc = cnNum ? rmbDescArr[i] : '';

      decimalRes += cnZero + cnNum + cnDesc;
    }
  }

  const res = integerRes === '零' ? decimalRes : integerRes + (decimalRes === '' ? '元整' : `元${decimalRes}`);

  return res
}